import { createAction, props } from '@ngrx/store';
import { AppExceptionModel } from '../../models/app-exception.model';
import { Podcast } from '../../models/podcast.model';

export const loadPodcast = createAction(
  '[Podcast] Load to store',
  props<{ podcasts: Podcast[]; lastSearchKey: any | null }>(),
);

export const getPodcasts = createAction(
  '[Podcast] Get podcasts',
  props<{ uid: string }>(),
);

export const getPodcast = createAction(
  '[Podcast] Get podcast',
  props<{ id: string }>(),
);

export const getPodcastsFailure = createAction(
  '[Podcast] Get Podcasts Failed',
  props<{ error: AppExceptionModel }>(),
);

// Create Podcast Actions
export const create = createAction(
  '[Podcast] Create podcast',
  props<{ podcast: Partial<Podcast> }>(),
);
export const createFailure = createAction(
  '[Podcast] Create podcast failure',
  props<{ error: any }>(),
);
export const createSuccess = createAction(
  '[Podcast] Create podcast success',
  props<{ podcast: Podcast }>(),
);

// Update Podcast Actions
export const update = createAction(
  '[Podcast] Update',
  props<{ podcast: Partial<Podcast> }>(),
);
export const updateFailure = createAction(
  '[Podcast] Update failure',
  props<{ error: any }>(),
);
export const updateSuccess = createAction(
  '[Podcast] Update success',
  props<{ podcast: Podcast }>(),
);

// Delete Podcast Actions
export const deleteAction = createAction(
  '[Podcast] Delete',
  props<{ id: string }>(),
);
export const deleteFailure = createAction(
  '[Podcast] Delete failure',
  props<{ error: any }>(),
);
export const deleteSuccess = createAction(
  '[Podcast] Delete success',
  props<{ id: string }>(),
);

export const clearFromStore = createAction(
  '[Podcast] Clear from store',
  props<{ id: string }>(),
);

export const select = createAction('[Podcast] Select', props<{ id: string }>());
export const unselect = createAction(
  '[Podcast] Unselect',
  props<{ id: string }>(),
);

export const clear = createAction('[Podcast] Clear Podcasts');
